// extracted by mini-css-extract-plugin
export var scrollArea = "_ph-0";